<template>
  <v-container v-if="userLoaded && user.can('view_rootentity')">
    <v-card outlined>
      <v-card-title>
        Queue Status
      </v-card-title>
      <v-card-text>
        <pre>{{ data }}</pre>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import ApiUtilitiesMixin from '@/components/mixins/ApiUtilitiesMixin'
import CurrentUserMixin from '@/components/mixins/CurrentUserMixin'

export default {
  name: 'QueueStatus',
  mixins: [
    ApiUtilitiesMixin,
    CurrentUserMixin
  ],
  data () {
    return {
      loading: true,
      data: null
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    /**
     * Retrieve the data from the API
     * @return {Promise<void>}
     */
    async fetchData () {
      this.loading = true
      try {
        const response = await this.$httpAdapter.get('queue-status/')
        this.data = response.data
      } catch (error) {
        this.renderErrorModal(error)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
